/**
 * IE11 creates new stack for z-index if positioned.
 * So explicitly making the outermost modal container positioned fixed to solve nested modal issue
 */
export function handleIERenderingIssues(modalDialog) {
  try {
    const el = modalDialog.parentElement.parentElement;
    if (el instanceof HTMLElement) {
      el.style.position = "fixed";
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}
